import axios from "axios";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Modal } from "react-materialize";
const CompletedRow = ({ orderItems }) => {
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(true);
  let started = moment(orderItems.data.now)
  let completed = moment(orderItems.completed)
  let secs = moment(completed).diff(started, 'seconds')
  let timeWaited = moment.utc(secs*1000).format('HH:mm:ss')
  let day = moment(orderItems.data.now).format("MMM Do YY");

  useEffect(() => {
    setTime(timeWaited);
    setLoading(false);
  }, []);

  const onDelete = (event) => {
    setLoading(true);
    axios.delete(`/completeTicket/${orderItems.ticketId}`).then(() => {
      console.log(`deleted ticket ${orderItems.ticketId}`);
      window.location.reload();
      setLoading(false);
    });
  };

  if (loading) return null;

  return (
    <>
      <div className="row">
        <table className="order-category-wrapper striped left">
          <tbody>
            <tr key={orderItems.ticketId}>
              <td className="table-col">{day}</td>
              <td className="table-col">{orderItems.data.userName}</td>
              <td className="table-col">{orderItems.data.title}</td>
              <td className="table-col">{orderItems.data.userPhone}</td>
              <td className="table-col">{orderItems.data.displayNow}</td>
              <td className="table-col">{time}</td>
              <td className="table-col">
                <Modal
                  trigger={
                    <button className="btn delete-queue">
                      <FontAwesomeIcon
                        className="blk"
                        icon={faTrash}
                        size="s"
                      />
                    </button>
                  }
                >
                  <div className="modal-container">
                    <h4>Confirm Delete</h4>
                    <p>Are you sure you want to delete this from your queue?</p>
                    <button className="btn submit-button" onClick={onDelete}>
                      Yes, Delete{" "}
                    </button>
                  </div>
                </Modal>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CompletedRow;
